<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar">
            <div class="left">&nbsp;</div>
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="right">
                <ons-toolbar-button>
                    <router-link v-bind:to="{ name: 'Outlets' }" v-bind:title="'Outlets'">
                        <i class="fal fa-times"/>
                    </router-link>
                </ons-toolbar-button>
            </div>
        </ons-toolbar>

        <div class="content main-background">
            <div class="content-inner">
                <template v-show="verified">
                    <v-ons-list class="section-h">
                        <div v-if="guest_user" class="main-header">Complete your account</div>
                        <div v-else class="main-header">Complete signup</div>

                        <form @submit.prevent="submit">
                            <v-ons-list-item v-if="user">
                                <div class="center">Email</div>
                                <div class="right">{{ user.email }}</div>
                            </v-ons-list-item>
                            <v-ons-list-item v-else-if="guest_user">
                                <div class="center">Email</div>
                                <div class="right">{{ guest_user.email }}</div>
                            </v-ons-list-item>
                            <v-ons-list-item>
                                <div class="center">
                                    <v-ons-input placeholder="Name" float v-model="form.name" name="name"/>
                                </div>
                            </v-ons-list-item>

                            <v-ons-list-item>
                                <div class="center">
                                    <v-ons-input placeholder="Phone" float v-model="form.phone" type="tel" name="phone"/>
                                </div>
                            </v-ons-list-item>
                            <v-ons-list-item>
                                <div class="center">
                                    <v-ons-input placeholder="Password" float v-model="form.password" type="password"
                                                  name="password"/>
                                </div>
                            </v-ons-list-item>
                        </form>
                    </v-ons-list>

                    <section class="section-vh">
                        <gtc-button modifier="large" v-on:click="submit" v-bind:disabled="can_signup == false" class="primary">
                            Complete signup
                        </gtc-button>
                    </section>
                </template>
            </div>
        </div>

         <validation v-bind:show="validation.show"
                    v-bind:errors="validation.errors"
                    v-on:show="(show) => validation.show = show"></validation>


    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'
    import ValidationComponent from '../fragments/validation'

    export default {
        components: {
            'validation': ValidationComponent,
        },

        data () {
            return {
                app: this.$root.$data.app,
                verified: false,
                form: {
                    name: '',
                    phone: '',
                    password: '',
                },
                message: '',
                complete: false,
                guest_user: null,
                login_info: null,
                validation: {
                    show: false,
                    errors: [],
                },
            }
        },

        mounted(){

            this.app.http.get('user/verify/' + this.$route.params.token)
                .then(response => {

                    this.app.analytics.track('verifyAccount')

                    this.login_info = response.data

                    if (response.data.is_guest == true) {
                        this.guest_user = response.data.user
                        this.form.name = response.data.user.name
                        this.form.phone = response.data.user.phone
                        return
                    }

                    this.$store.commit('login', response.data)
                    this.verified = true

                    // If user has completed already, go to outlets
                    if (response.data.user_complete) {
                        this.$ons.notification.alert(
                            'Thanks for verifying your email address, your account is now active.',
                            { title: 'You\'re all set' }
                        )

                        this.$nextTick(() => {
                            this.$router.push(this.app.homeRoute())
                        })
                    }
                })
                .catch(error => {
                    this.$ons.notification.alert(this.app.getResponseErrorMessage(error))
                })
        },

        methods: {

            submit(){
                if (this.can_submit == false)
                    return

                this.$store.commit('login', this.login_info)
                this.verified = true

                this.app.http.post('user/complete', this.form)
                    .then(response => {
                        this.complete = true
                        this.message = response.data.message
                        // update info if guest
                        if (this.guest_user) {
                            this.login_info.is_guest = false
                            this.login_info.user = response.data.user
                            this.$store.commit('login', this.login_info)
                        }
                        this.$ons.notification.alert(
                            'Thanks for verifying your email address, your account is now active.',
                            { title: 'You\'re all set' }
                        )

                        this.$nextTick(() => {
                            this.$router.push(this.app.homeRoute())
                        })
                    })
                    .catch(error => {
                        
                        if (error.response && error.response.data && error.response.data.hasOwnProperty('errors')) {
                            this.validation.errors = Object.values(error.response.data.errors).map(e => e[0])
                            this.validation.show = true
                        } else {
                            this.$ons.notification.alert(this.app.getResponseErrorMessage(error))
                        }
                    })
            },

            declineSignup(){
                this.$ons.notification.alert(
                    'Thanks for verifying your email address, your guest account is now active.',
                    { title: 'You\'re all set' }
                )

                this.$nextTick(() => {
                    this.$router.push(this.app.homeRoute())
                })
            }
        },

        computed: {

            ...mapGetters([
                'user',
                'embed',
            ]),

            can_signup: function(){
                const fields = ['name', 'phone', 'password']
                return fields.every(f => this.form[f] && this.form[f].length > 0)
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/user/verify.vue